export default {
  title: 'Se connecter',
  login: 'Votre adresse email',
  loginWarning: 'Veuillez renseigner un identifiant',
  password: 'Votre mot de passe',
  passwordWarning: 'Veuillez renseigner un mot de passe',
  recoverPassword: 'Mot de passe oublié ?',
  loginSubmit: 'Se connecter',
  registerText: 'Besoin d\'un compte Nextories ?',
  registerBtn: 'Créer un compte',
  impersonation: {
    label: 'Dossier de test',
    placeholder: 'Choisir un dossier en cours',
  },
  imageTitle: 'Profitez, on s\'occupe de votre déménagement',
  imageSubtitle: 'Nous vous accompagnons gratuitement dans votre sélection de déménageurs et vos transferts de contrats.',
  tokenFail: {
    title: {
      default: 'Votre lien a été désactivé',
      notValid: 'Jeton non valide',
    },
    AUTO_LOGIN_EXPIRED: 'Après 30 jours d’inactivité sur votre espace client, ce lien a été désactivé pour la sécurité de vos informations personnelles. Si vous souhaitez accéder aux informations liées à votre déménagement, veuillez contacter notre service client par téléphone au 01 82 52 10 12.',
    AUTO_LOGIN_DEFINED_PASSWORD: 'Utilisez votre mot de passe pour vous connecter.',
    AUTO_LOGIN_PROJECT_ERROR: 'Ce lien n\'est pas valide. Utilisez votre mot de passe pour vous connecter.',
    AUTO_LOGIN_FALSE_KEY: 'Ce lien n\'est pas valide. Utilisez votre mot de passe pour vous connecter.',
    AUTO_LOGIN_COOKIE_DISABLE: 'Ce site nécessite l\'utilisation de cookies pour fonctionner. Veuillez activer les cookies dans les préférences de votre navigateur et réessayez.',
    AUTO_LOGIN_COOKIE_DISABLE_TITLE: 'Une erreur est survenue',
    AUTO_LOGIN_UNKNOWN_ERROR: 'Une erreur inconnue est survenue',
    token_not_valid: 'Votre jeton d\'authentification n\'est plus valide ou a expiré. Veuillez vous reconnecter si vous avez créé un mot de passe ou bien cliquez sur le lien que vous avez reçu par email.',
  },
  cookie: {
    help: 'Besoin d\'aide pour activer vos cookies ?',
  },
};
